export interface Messenger451 {
  open: () => void;
  ask: (question: string) => void;
  askAssistant: (
    question: string,
    assistantGuid: string,
    context?: any
  ) => void;
  talkToAssistant: (assistantGuid: string, context?: any) => void;
  close: () => void;
  addEventListener: (
    eventType: 'close' | 'resize' | 'open' | 'position' | 'handshake',
    callback: (event?: any) => void
  ) => void;
  removeEventListener: (
    eventType: 'close' | 'resize' | 'open' | 'position' | 'handshake',
    callback: (event?: any) => void
  ) => void;
}

export interface BoltDiscovery {
  open: () => void;
  ask: (question: string) => void;
  openPreviousThreads: () => void;
  openThread: (threadSlug: string) => void;
  close: () => void;
}

export interface Shell451Window extends Window {
  Shell451: {
    _shells: Set<string>;
    Messenger451: Messenger451;
    BoltDiscovery: BoltDiscovery;
  };
}

export const getShellWindow = () => window as unknown as Shell451Window;
